import '../styles/bowliver.css';
import bowliver from 'url:../assets/bowliver.png';

export function BowliversWorld() {
    return <div className='bowliver-page'>
        <div className='bowliver-header-box'><div className='bowliver-header'>
            BOWLIVER'S WORLD
        </div></div>
        <div className='bowliver-body'>
            <img src={bowliver} width={512}/>
            <div className='bowliver-options'>
                <a className='bowliver-option' href='bowliver'>my diary</a>
                <a className='bowliver-option' href='bowliver'>my mom</a>
                <a className='bowliver-option' href='bowliver'>my pics</a>
            </div>
        </div>
    </div>
}